import { useNavigate } from "react-router-dom";
import { ShieldCheck, Award, LogOut, PenLine } from "lucide-react";
import { TopBar } from "@/components/fly/Logo";
import { HomeTile } from "@/components/fly/HomeTile";
import { clearSession, getSession } from "@/lib/api";

const tiles = [
  { to: "/dyplomy/login", icon: Award, title: "Zawody", desc: "Dyplomy zwycięzców i uczestników oraz listy wyników według kategorii (PDF).", id: "org-diplomas-link" },
  { to: "/admin", icon: ShieldCheck, title: "Organizator", desc: "Lista startowa, użytkownicy, postęp sędziów, wyniki, widok publiczny i eksport.", id: "org-admin-link" },
  { to: "/organizacja/zapisy", icon: PenLine, title: "Zapisy", desc: "Zgłoszenia, plan zawodów (dni, kolejność, godziny) z eksportem do listy startowej, kategorie, data i miejsce, nowa edycja.", id: "org-signups-link", color: "text-amber-300" },
];

export default function Organization({ login = false }) {
  const nav = useNavigate();
  const s = getSession();
  const logout = () => { clearSession(); nav("/"); };
  return (
    <>
      <TopBar title={login ? "Logowanie obsługi" : "Organizacja"} right={!login && (
        <button data-testid="org-logout-btn" onClick={logout} className="h-10 px-3 rounded-lg border border-white/10 text-slate-300 hover:text-white hover:bg-white/5 flex items-center gap-2 text-sm">
          <LogOut className="w-4 h-4" /><span className="hidden sm:inline">Wyloguj</span>
        </button>
      )} />
      <main className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400">
          {login ? "FLY CUP 2026 · tylko dla obsługi zawodów" : `Zalogowano: ${s?.name || s?.email || ""}`}
        </p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase">{login ? "Logowanie obsługi" : "Organizacja"}</h1>
        <p className="text-sm text-slate-400 mt-2 max-w-2xl">
          {login ? "Wybierz swój panel i zaloguj się PIN-em od organizatora lub hasłem organizatora. Po zalogowaniu na stronie głównej pojawi się panel Organizacja." : "Każdy panel wymaga własnego logowania."}
        </p>
        <div className="mt-8 max-w-2xl grid gap-4" data-testid={login ? "staff-login-tiles" : "org-tiles"}>
          {tiles.map((t, i) => <HomeTile key={t.to} t={t} i={i} className={i === 1 ? "mt-6" : ""} />)}
        </div>
      </main>
    </>
  );
}
